@if (showNotification && !oneSignalService.isDismissed()) {
<div
  class="push-notification"
  [class.main-head-notification]="notificationData?.style === 'promotional'"
  [style.background]="notificationData?.style === 'promotional' ? notificationData?.background : null"
>
  <div class="notification-header">
    <div class="header">
      <div class="bell-wrapper">
        <img [src]="getIconUrl(notificationData?.icon_url)" alt="Bell icon">
      </div>
      <p [innerHTML]="displayContent?.title || ('vouchers.enable_push' | translate)"></p>
    </div>
    <img [src]="'../../../assets/icon/' + (notificationData?.style === 'promotional' ? 'close-circle.svg' : 'close-gray.svg')" alt="Close Notification" class="close-notify"
      (click)="dismissNotification()" />
  </div>
  <div class="notify-content">
    <div>
      @if (issuedStateReady) {
        @if (!isFreeLineClaimed) {
        <p class="content-title"
          [innerHTML]="displayContent?.line_1 || ('vouchers.claim_free_lines' | translate)"></p>
        } @else {
        <p class="content-title"
          [innerHTML]="displayContent?.line_1_alt || ('vouchers.never_miss' | translate)"></p>
        }
      }
      <p class="content-subtitle"
        [innerHTML]="displayContent?.line_2 || ('vouchers.unlock_offer' | translate)"></p>
    </div>
    <button
      class="active-btn"
      type="button"
      (click)="activateNotification(); $event.stopPropagation()"
    >
      {{ displayContent?.button_label || ("vouchers.activate" | translate) }}
    </button>
  </div>
</div>
}
